/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ShareSignatureIcon = createIcon("ShareSignatureIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("circle", {
    cx: "80",
    cy: "80",
    r: "80",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.635 78.044 16.97-16.97 8.486 8.485-16.97 16.97-8.486-8.485Zm35.357-18.387 2.827 2.829a4 4 0 010 5.656L96.091 80.87m-.001-11.312 9.902-9.902a4 4 0 000-5.655l-2.829-2.83a4.001 4.001 0 00-5.656 0l-9.902 9.896",
    stroke: "#fff",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.877 90.771c-2.341 2.341-11.312 2.827-11.312 2.827s.486-8.97 2.827-11.312a6 6 0 018.485 8.485v0ZM57.992 98H56a6 6 0 100 12h42",
    stroke: "#fff",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});